import React from 'react';
import { motion } from 'framer-motion';
export function BenefitsGrid() {
  const benefits = [{
    emoji: '🌙',
    title: 'Noches tranquilas otra vez',
    description: 'Tu hijo se duerme en menos de 15 minutos sin berrinches.'
  }, {
    emoji: '💖',
    title: 'Más conexión emocional',
    description: 'Un ritual diario para crear vínculos profundos.'
  }, {
    emoji: '✨',
    title: 'Niños más seguros',
    description: 'Cuentos que enseñan valores: empatía, valentía y calma.'
  }, {
    emoji: '⏰',
    title: 'Tiempo para vos',
    description: 'Recuperá tus noches y descansá de verdad.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-white/40" data-id="element-30">
      <div className="max-w-5xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-32">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-indigo mb-6" data-id="element-33">
            Lo que vas a lograr
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-34">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-8 rounded-3xl text-center shadow-sm hover:-translate-y-1 transition-transform duration-300" data-id="element-35">
              <div className="text-5xl mb-6" data-id="element-36">{benefit.emoji}</div>
              <h3 className="text-xl font-serif font-medium text-indigo mb-3" data-id="element-37">
                {benefit.title}
              </h3>
              <p className="text-indigo/70 leading-relaxed" data-id="element-38">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}